<!--
 * @Description:
 * @Author: kangkang
 * @Date: 2022-07-01 16:54:59
 * @LastEditTime: 2023-04-13 22:48:19
 * @LastEditors: kangkang
 * @Reference:
-->
<template>
    <van-popup
        v-model="show"
        position="bottom"
        :style="{ height: '50%' }"
        overlay-class="mask-time"
        :safe-area-inset-bottom="true"
    >
        <van-datetime-picker
            v-model="currentDate"
            type="datetime"
            title="选择时间"
            :min-date="minDate"
            :max-date="maxDate"
            :formatter="formatter"
            :filter="filter" 
            @confirm="confirm"
            @cancel="cancel"
        />
    </van-popup>
</template>
<script>
import { months } from 'moment';
    export default{
        name:"mask-time",
        data() {
            return {
                show: true,
                currentNum: "",
                minDate: new Date(parseInt(this.$moment(new Date()).add(1,'hours').valueOf())),
                maxDate: new Date(parseInt(this.$moment(new Date()).add(2,'days').valueOf())),
                currentDate: new Date(),
            }
        },
        props: {
            timeshow: {
                type: Boolean
            },
            data: {
                type: Array
            }
        },
        watch: {
            timeshow(val) {
                this.show = val;
            }
        },
        methods: {
            // 設置時間顯示格式
            formatter(type,val) {
                if(type == "year"){
                    return `${val}年`
                } else if(type == "month") {
                    return `${val}月`
                } else if(type == "day") {
                    return `${val}日`
                } else if(type == "hour") {
                    return `${val}时`
                } else if(type == "minute") {
                    return `${val}分`
                }
                return val;
            },
            // 分钟要十分钟为间隔
            filter(type, options) {
                if (type === 'minute') {
                    return options.filter((option) => option % 10 === 0);
                }
                return options;
            },
            confirm(val) {
                let data = {
                    time: this.$moment(val).format("YYYY-MM-DD HH:mm"),
                    show: false
                }
                this.$emit('timerConfirm',data)
            },
            cancel() {
                this.show = false;
                this.$emit('timerCancel',false)
            }
        },
        created() {

        }
    }
</script>
<style rel="stylesheet/scss" lang="scss">
.mask-time {
    width: 100%;
    height: 100%;
    &-title {
        font-size: px2rem(34);
        color: #000000;
        text-align: center;
        margin-top: px2rem(50);
        margin-bottom: px2rem(42);
    }

}
.van-popup--bottom {
    left: 50%;
}
.van-popup__close-icon {
    font-size: px2rem(30);
    top: px2rem(60);
}
</style>
